<template>
    <div class="SearchPage">
        <NavMenu/>
        <div class="centerbox">
            <div class="searchBox">
                <el-input placeholder="请输入内容" v-model="searchVal" class="input-with-select" @keyup.enter.native="searchFn">
                    <el-button slot="append" @click="searchFn">搜索</el-button>
                </el-input>
                <div class="searchtext">为您搜索到
                    <span class="text">{{total}}</span>条关于"
                    <span class="text">{{searchVal}}</span>"的信息</div>
            </div>
            <div class="searchinfo" v-if="dataList.length!=0">
                <div class="datalistBox">
                    <div class="leftImgRightTextBox">
                        <div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                            <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                            <div class="contentbox">
                                <div class="title overflowone">{{item.pressTopic}}</div>
                                <div class="synopsis overflowthree">{{item.synopsis}}</div>
                                <div class="time">{{item.pressTime | timer}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination-box">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                        :page-sizes="[6, 9,12,15]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
            <div class="emptyBox" v-else>
                <img src="@/assets/imgs/home/emptyimg.png" />
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer
    },
    data() {
        return {
            srcUrl: srcUrl,
            searchVal: '',
            currentPage: 1,
            total: 10,
            pageSize: 6,
            dataList: []
        }
    },
    watch: {
        $route: {
            handler: function (newval, oldVal) {
                if (newval.query.val) {
                    this.searchVal = this.$route.query.val
                    this.getNews()
                }
                let currentNew = JSON.parse(sessionStorage.getItem('currentNew'))
                if (currentNew) {
                    if (currentNew.currentPage) {
                        this.currentPage = currentNew.currentPage * 1;
                        // this.getNews();
                    }
                    if (currentNew.site) {
                        document.body.scrollTop = currentNew.site
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        // console.log(this.$route.query.val);
        // let val=this.$route.query.val
        // console.log(val,'val');
        this.searchVal = sessionStorage.getItem("searchVal");
        // this.searchVal = this.$route.query.val

    },
    mounted() {
        this.getNews()
    },
    methods: {
        searchFn() {
            this.getNews()
        },
        async getNews() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                findContent: this.searchVal,
            };
            let data = await httpService.findNewsList(params);
            if (data.code == 200) {
                this.dataList = data.result.list
                this.total = data.result.total;
                this.$router.push({ query: {} });
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getNews();
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.getNews();
        },
        goNewsDetailFn(val) {
            let currentNew = {
                menuurl: '/search',
                currentPage: this.currentPage,
                site: window.scrollY,
                title: '搜索中心'
            }
            sessionStorage.setItem('currentNew', JSON.stringify(currentNew))
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        }

    },
    filters: {
        timer: (value) => {
            return value.substring(0, 7);
        },
        day: (value) => {
            return value.substring(8, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.SearchPage {
	width: 100%;
	margin: 0 auto;
	.centerbox {
		width: 1200px;
		margin: 0 auto;
		min-height: 380px;
		.searchBox {
			width: 1200px;
			margin: 50px auto 27px auto;
			/deep/.el-button {
				width: 130px;
				background: #448df7;
				height: 60px;
				font-size: 22px;
				line-height: 36px;
				color: #ffffff;
				border-radius: 0 8px 8px 0;
				border: none;
			}
			/deep/.el-input__inner {
				height: 60px;
				line-height: 60px;
			}
			/deep/.el-input-group__append,
			.el-input-group__prepend {
				border: none;
			}
			.searchtext {
				margin-top: 27px;
				text-align: center;
				color: #999999;
				.text {
					color: #448df7;
				}
			}
		}
		.datalistBox {
			.leftImgRightTextBox {
				.itemBox {
					margin: 0 0 40px 0;
					width: 100%;
					cursor: pointer;
					.imgbox {
						width: 301px;
						height: 152px;
					}
					.contentbox {
						width: 77%;
						.time {
							margin-top: 0;
						}
					}
				}
			}
		}
	}
}
</style>


